import { render, staticRenderFns } from "./EarthIcon.vue?vue&type=template&id=89ea376c&scoped=true&"
var script = {}
import style0 from "./EarthIcon.vue?vue&type=style&index=0&id=89ea376c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ea376c",
  null
  
)

export default component.exports